function isLoggedIn() {
    const loggedIn = localStorage.getItem("loggedIn") === "true"; 
    
    return loggedIn;
}

export default isLoggedIn;